module.exports = __webpack_public_path__ + "media/images/icons/sun-black-ac7fc84956d6f0e216ef7134e7bedfa6.svg";